import { MutationTree } from 'vuex';
import { URLState } from '../../models';
import { SetStateFromUrlMutation } from './mutations/set-state-from-url.mutation';
import { SetUrlMutation } from './mutations/set-url.mutation';

export const URL_MUTATIONS: MutationTree<URLState> = {
  ...new SetUrlMutation().mutations,
  ...new SetStateFromUrlMutation().mutations
};
